import update from 'immutability-helper';
import { ModalActionTypes, ModalState } from './types';

export const initialState: ModalState = {
	showModal: false,
	modal: undefined,
	modalsVisibility: {},
};

export const modalReducer: (state: ModalState | undefined, action: any) => ModalState = (
	state = initialState,
	action
): ModalState => {
	switch (action.type) {
		case ModalActionTypes.OPEN: {
			return { ...state, showModal: true, modal: action.payload };
		}
		case ModalActionTypes.CLOSE: {
			return { ...state, showModal: false };
		}
		case ModalActionTypes.SHOW: {
			let modalsVisibility: any = state.modalsVisibility === undefined ? [] : state.modalsVisibility;
			const modalId: string = action.payload.modalId;

			modalsVisibility = update(modalsVisibility, { [modalId]: { $set: true } });

			return {
				...state,
				modalsVisibility,
			};
		}
		case ModalActionTypes.HIDE: {
			let modalsVisibility: any = state.modalsVisibility === undefined ? [] : state.modalsVisibility;
			const modalId: string = action.payload.modalId;

			modalsVisibility = update(modalsVisibility, { [modalId]: { $set: false } });

			return {
				...state,
				modalsVisibility,
			};
		}
		default: {
			return state;
		}
	}
};
